import axios from 'axios';

const apikey = '96d7e4737eb745548bf5e049c6c20036';

export default {
  getAll() {
    return axios({
      method: 'get',
      url: 'https://api.getpostman.com/collections/7228494-adf874f2-0f39-4565-b064-62706e99875b',
      headers: { 'X-Api-Key': apikey },
    })
      .then((response) => response)
      .catch((error) => console.error(error))
      .finally(() => {
        //
      });
  },
};
